import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import SmartParking from './components/SmartParking/SmartParking';
import Services from './components/Services/Services';
import Location from './components/Location/Location';
import ParkingRates from './components/ParkingRates/ParkingRates';
import ParkingOptions from './components/ParkingOptions/ParkingOptions';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Careers from './components/Careers/Careers';
import FAQ from './components/FAQ/FAQ';
import Footer from './components/Footer/Footer';
import KPCard from './components/KPCard/KPCard';
import KPCardRecharge from './components/KPCard/KPCardRecharge';
import KPCardRechargeSuccess from './components/KPCard/KPCardRechargeSuccess';
import KPCardRechargeFailed from './components/KPCard/KPCardRechargeFailed';
import OpenTickets from './components/KPCard/OpenTickets';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Services />
                <Location />
                <SmartParking />
                <FAQ />
                <ParkingRates />
              </>
            } />
            <Route path="/kp-card" element={<KPCard />} />
            <Route path="/kp-card/recharge" element={<KPCardRecharge />} />
            <Route path="/kp-card/recharge/success" element={<KPCardRechargeSuccess />} />
            <Route path="/kp-card/recharge/failed" element={<KPCardRechargeFailed />} />
            <Route path="/kp-card/recharge/callback" element={<KPCardRechargeSuccess />} />
            <Route path="/kp-card/open-tickets" element={<Navigate to="/smart-parking/open-tickets" replace />} />
            <Route path="/parking-options" element={<ParkingOptions />} />
            <Route path="/smart-parking" element={<SmartParking />} />
            <Route path="/smart-parking/open-tickets" element={<OpenTickets />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 